// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/alert_rules_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AlertCondition, AlertRuleSeverity, CustomFieldConditionsGroup, Rule, SignalTypeOption, ThirdPartyInherentRiskQuestion } from "./alert_rule_pb";
import { file_inventory_v1_alert_rule } from "./alert_rule_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/alert_rules_service.proto.
 */
export const file_inventory_v1_alert_rules_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_inventory_v1_alert_rule]);

/**
 * ListAlertRulesRequest is intentionally empty: the rules table filters
 * (by signal type, by enabled status) live entirely on the FE.
 *
 * @generated from message inventory.v1.ListAlertRulesRequest
 */
export type ListAlertRulesRequest = Message<"inventory.v1.ListAlertRulesRequest"> & {
};

/**
 * Describes the message inventory.v1.ListAlertRulesRequest.
 * Use `create(ListAlertRulesRequestSchema)` to create a new message.
 */
export const ListAlertRulesRequestSchema: GenMessage<ListAlertRulesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 0);

/**
 * @generated from message inventory.v1.ListAlertRulesResponse
 */
export type ListAlertRulesResponse = Message<"inventory.v1.ListAlertRulesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Rule rules = 1;
   */
  rules: Rule[];
};

/**
 * Describes the message inventory.v1.ListAlertRulesResponse.
 * Use `create(ListAlertRulesResponseSchema)` to create a new message.
 */
export const ListAlertRulesResponseSchema: GenMessage<ListAlertRulesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 1);

/**
 * @generated from message inventory.v1.GetAlertRuleRequest
 */
export type GetAlertRuleRequest = Message<"inventory.v1.GetAlertRuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.GetAlertRuleRequest.
 * Use `create(GetAlertRuleRequestSchema)` to create a new message.
 */
export const GetAlertRuleRequestSchema: GenMessage<GetAlertRuleRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 2);

/**
 * GetAlertRuleResponse carries the rule's saved values and the per-signal-
 * type catalog of conditions the editor offers — one round-trip populates
 * the entire editor state.
 *
 * @generated from message inventory.v1.GetAlertRuleResponse
 */
export type GetAlertRuleResponse = Message<"inventory.v1.GetAlertRuleResponse"> & {
  /**
   * @generated from field: inventory.v1.Rule rule = 1;
   */
  rule?: Rule;

  /**
   * @generated from field: repeated inventory.v1.CustomFieldConditionsGroup custom_field_conditions_groups = 2;
   */
  customFieldConditionsGroups: CustomFieldConditionsGroup[];

  /**
   * @generated from field: repeated inventory.v1.AlertCondition alert_conditions = 3;
   */
  alertConditions: AlertCondition[];

  /**
   * @generated from field: inventory.v1.ThirdPartyInherentRiskQuestion third_party_inherent_risk_question = 4;
   */
  thirdPartyInherentRiskQuestion?: ThirdPartyInherentRiskQuestion;
};

/**
 * Describes the message inventory.v1.GetAlertRuleResponse.
 * Use `create(GetAlertRuleResponseSchema)` to create a new message.
 */
export const GetAlertRuleResponseSchema: GenMessage<GetAlertRuleResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 3);

/**
 * @generated from message inventory.v1.CreateAlertRuleRequest
 */
export type CreateAlertRuleRequest = Message<"inventory.v1.CreateAlertRuleRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string signal_type_id = 2;
   */
  signalTypeId: string;

  /**
   * @generated from field: repeated inventory.v1.CustomFieldConditionsGroup custom_field_conditions_groups = 3;
   */
  customFieldConditionsGroups: CustomFieldConditionsGroup[];

  /**
   * @generated from field: repeated inventory.v1.AlertCondition alert_conditions = 4;
   */
  alertConditions: AlertCondition[];

  /**
   * @generated from field: inventory.v1.ThirdPartyInherentRiskQuestion third_party_inherent_risk_question = 5;
   */
  thirdPartyInherentRiskQuestion?: ThirdPartyInherentRiskQuestion;

  /**
   * PASSTHROUGH only for types with supports_passthrough_severity.
   *
   * @generated from field: inventory.v1.AlertRuleSeverity severity = 6;
   */
  severity: AlertRuleSeverity;
};

/**
 * Describes the message inventory.v1.CreateAlertRuleRequest.
 * Use `create(CreateAlertRuleRequestSchema)` to create a new message.
 */
export const CreateAlertRuleRequestSchema: GenMessage<CreateAlertRuleRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 4);

/**
 * @generated from message inventory.v1.CreateAlertRuleResponse
 */
export type CreateAlertRuleResponse = Message<"inventory.v1.CreateAlertRuleResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.CreateAlertRuleResponse.
 * Use `create(CreateAlertRuleResponseSchema)` to create a new message.
 */
export const CreateAlertRuleResponseSchema: GenMessage<CreateAlertRuleResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 5);

/**
 * UpdateAlertRuleRequest is a full-replacement contract for the rule. Every
 * field is required and overrides what's stored. Enable/disable lives on the
 * dedicated EnableAlertRule / DisableAlertRule RPCs and is intentionally
 * absent here.
 *
 * @generated from message inventory.v1.UpdateAlertRuleRequest
 */
export type UpdateAlertRuleRequest = Message<"inventory.v1.UpdateAlertRuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string signal_type_id = 3;
   */
  signalTypeId: string;

  /**
   * @generated from field: repeated inventory.v1.CustomFieldConditionsGroup custom_field_conditions_groups = 4;
   */
  customFieldConditionsGroups: CustomFieldConditionsGroup[];

  /**
   * @generated from field: repeated inventory.v1.AlertCondition alert_conditions = 5;
   */
  alertConditions: AlertCondition[];

  /**
   * @generated from field: inventory.v1.ThirdPartyInherentRiskQuestion third_party_inherent_risk_question = 6;
   */
  thirdPartyInherentRiskQuestion?: ThirdPartyInherentRiskQuestion;

  /**
   * PASSTHROUGH only for types with supports_passthrough_severity.
   *
   * @generated from field: inventory.v1.AlertRuleSeverity severity = 7;
   */
  severity: AlertRuleSeverity;
};

/**
 * Describes the message inventory.v1.UpdateAlertRuleRequest.
 * Use `create(UpdateAlertRuleRequestSchema)` to create a new message.
 */
export const UpdateAlertRuleRequestSchema: GenMessage<UpdateAlertRuleRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 6);

/**
 * @generated from message inventory.v1.UpdateAlertRuleResponse
 */
export type UpdateAlertRuleResponse = Message<"inventory.v1.UpdateAlertRuleResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateAlertRuleResponse.
 * Use `create(UpdateAlertRuleResponseSchema)` to create a new message.
 */
export const UpdateAlertRuleResponseSchema: GenMessage<UpdateAlertRuleResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 7);

/**
 * @generated from message inventory.v1.EnableAlertRuleRequest
 */
export type EnableAlertRuleRequest = Message<"inventory.v1.EnableAlertRuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.EnableAlertRuleRequest.
 * Use `create(EnableAlertRuleRequestSchema)` to create a new message.
 */
export const EnableAlertRuleRequestSchema: GenMessage<EnableAlertRuleRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 8);

/**
 * @generated from message inventory.v1.EnableAlertRuleResponse
 */
export type EnableAlertRuleResponse = Message<"inventory.v1.EnableAlertRuleResponse"> & {
};

/**
 * Describes the message inventory.v1.EnableAlertRuleResponse.
 * Use `create(EnableAlertRuleResponseSchema)` to create a new message.
 */
export const EnableAlertRuleResponseSchema: GenMessage<EnableAlertRuleResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 9);

/**
 * @generated from message inventory.v1.DisableAlertRuleRequest
 */
export type DisableAlertRuleRequest = Message<"inventory.v1.DisableAlertRuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.DisableAlertRuleRequest.
 * Use `create(DisableAlertRuleRequestSchema)` to create a new message.
 */
export const DisableAlertRuleRequestSchema: GenMessage<DisableAlertRuleRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 10);

/**
 * @generated from message inventory.v1.DisableAlertRuleResponse
 */
export type DisableAlertRuleResponse = Message<"inventory.v1.DisableAlertRuleResponse"> & {
};

/**
 * Describes the message inventory.v1.DisableAlertRuleResponse.
 * Use `create(DisableAlertRuleResponseSchema)` to create a new message.
 */
export const DisableAlertRuleResponseSchema: GenMessage<DisableAlertRuleResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 11);

/**
 * @generated from message inventory.v1.DeleteAlertRuleRequest
 */
export type DeleteAlertRuleRequest = Message<"inventory.v1.DeleteAlertRuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.DeleteAlertRuleRequest.
 * Use `create(DeleteAlertRuleRequestSchema)` to create a new message.
 */
export const DeleteAlertRuleRequestSchema: GenMessage<DeleteAlertRuleRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 12);

/**
 * @generated from message inventory.v1.DeleteAlertRuleResponse
 */
export type DeleteAlertRuleResponse = Message<"inventory.v1.DeleteAlertRuleResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteAlertRuleResponse.
 * Use `create(DeleteAlertRuleResponseSchema)` to create a new message.
 */
export const DeleteAlertRuleResponseSchema: GenMessage<DeleteAlertRuleResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 13);

/**
 * @generated from message inventory.v1.ListSignalTypesRequest
 */
export type ListSignalTypesRequest = Message<"inventory.v1.ListSignalTypesRequest"> & {
};

/**
 * Describes the message inventory.v1.ListSignalTypesRequest.
 * Use `create(ListSignalTypesRequestSchema)` to create a new message.
 */
export const ListSignalTypesRequestSchema: GenMessage<ListSignalTypesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 14);

/**
 * @generated from message inventory.v1.ListSignalTypesResponse
 */
export type ListSignalTypesResponse = Message<"inventory.v1.ListSignalTypesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.SignalTypeOption signal_types = 1;
   */
  signalTypes: SignalTypeOption[];
};

/**
 * Describes the message inventory.v1.ListSignalTypesResponse.
 * Use `create(ListSignalTypesResponseSchema)` to create a new message.
 */
export const ListSignalTypesResponseSchema: GenMessage<ListSignalTypesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert_rules_service, 15);

/**
 * AlertRuleService manages alert rules: CRUD, enable/disable, and the
 * signal-type catalog that drives the rule editor's question dropdowns.
 * Mutations emit ALERT_RULE_UPDATE_TOPIC so services/engine/alertrules
 * recomputes the affected org. Implementations land in ENG-2984 (CRUD +
 * ListSignalTypes); the live-counter helper lives there as an internal
 * util (CountAlertsForRules) that populates Rule.alert_count_last_30_days
 * on ListAlertRules / GetAlertRule.
 *
 * @generated from service inventory.v1.AlertRuleService
 */
export const AlertRuleService: GenService<{
  /**
   * @generated from rpc inventory.v1.AlertRuleService.ListAlertRules
   */
  listAlertRules: {
    methodKind: "unary";
    input: typeof ListAlertRulesRequestSchema;
    output: typeof ListAlertRulesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AlertRuleService.GetAlertRule
   */
  getAlertRule: {
    methodKind: "unary";
    input: typeof GetAlertRuleRequestSchema;
    output: typeof GetAlertRuleResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AlertRuleService.CreateAlertRule
   */
  createAlertRule: {
    methodKind: "unary";
    input: typeof CreateAlertRuleRequestSchema;
    output: typeof CreateAlertRuleResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AlertRuleService.UpdateAlertRule
   */
  updateAlertRule: {
    methodKind: "unary";
    input: typeof UpdateAlertRuleRequestSchema;
    output: typeof UpdateAlertRuleResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AlertRuleService.EnableAlertRule
   */
  enableAlertRule: {
    methodKind: "unary";
    input: typeof EnableAlertRuleRequestSchema;
    output: typeof EnableAlertRuleResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AlertRuleService.DisableAlertRule
   */
  disableAlertRule: {
    methodKind: "unary";
    input: typeof DisableAlertRuleRequestSchema;
    output: typeof DisableAlertRuleResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AlertRuleService.DeleteAlertRule
   */
  deleteAlertRule: {
    methodKind: "unary";
    input: typeof DeleteAlertRuleRequestSchema;
    output: typeof DeleteAlertRuleResponseSchema;
  },
  /**
   * Returns each user-visible signal type plus the questions and options the
   * rule editor offers when that signal type is selected. Drives the editor's
   * signal-type picker and per-question dropdowns. Legacy WOW-typed findings
   * are excluded.
   *
   * @generated from rpc inventory.v1.AlertRuleService.ListSignalTypes
   */
  listSignalTypes: {
    methodKind: "unary";
    input: typeof ListSignalTypesRequestSchema;
    output: typeof ListSignalTypesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_alert_rules_service, 0);

